export default __webpack_public_path__ + "static/media/single-project-page-05-img-20.15330465.jpg";